<template>
  <img :src="iconUrl" :alt="subType"/>
</template>

<script>
import globals from '@/globals';

/**
 * Supported filetype icons
 * ``` cd imperia/mime
 * ``` find . -type f -name 'md.svg' | sed -r 's|/[^/]+$||' |sort |uniq
 */
const supportedMimeTypeIcons = [
  'application',
  'application/excel',
  'application/msword',
  'application/octet-stream',
  'application/pdf',
  'application/powerpoint',
  'application/rtf',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.oasis.opendocument.formula',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/x-compress',
  'application/x-director',
  'application/x-gtar',
  'application/x-gzip',
  'application/x-httpd-php',
  'application/x-shockwave-flash',
  'application/x-zip-compressed',
  'application/xml',
  'application/zip',
  'audio',
  'audio/basic',
  'audio/mpeg',
  'audio/x-pn-realaudio',
  'audio/x-pn-realaudio-plugin',
  'audio/x-realaudio',
  'audio/x-wav',
  'image',
  'text',
  'text/comma-separated-values',
  'text/csv',
  'text/html',
  'text/plain',
  'text/xml',
  'video',
  'video/quicktime',
];

// Returns all but the last element of the given list or string.
const init = (arr) => arr.slice(0, -1);

/**
 * Resolves the supported mime type.
 * 'text/plain' -> 'text/plain' (supported)
 * 'video/mpeg' -> 'video' (parent type)
 * 'unknown/type' -> '' (not supported)
 */
function resolveMimeType(mimeType) {
  if (!mimeType) return '';
  if (supportedMimeTypeIcons.includes(mimeType)) return mimeType;
  const parts = mimeType.split('/');
  const parentType = init(parts).join('/');
  return resolveMimeType(parentType);
}

/**
 * Return the sub type
 * If the is no subtype, return the parent type
 * 'text/html' -> 'html' (subtype)
 * 'image' -> 'image' (parent)
 */
function getSubType(mimeType) {
  if (!mimeType) return '';
  const parts = mimeType.split('/');
  const subType = parts.pop();

  return subType;
}

const normalisedMimeSubTypes = {
  'x-httpd-php': 'php',
};

function normaliseSubType(subType) {
  if (!subType) return '';

  if (normalisedMimeSubTypes[subType]) {
    return normalisedMimeSubTypes[subType];
  }

  return subType;
}

export default {
  props: {
    mimeType: {
      type: String,
    },
  },
  computed: {
    iconUrl() {
      const mimeType = resolveMimeType(this.mimeType);
      return mimeType ? `/imperia/mime/${mimeType}/md.svg` : '/imperia/mime/md.svg';
    },
    subType() {
      return globals.I.gt.__x('{type} file', {
        type: normaliseSubType(getSubType(this.mimeType)),
      });
    },
  },
};
</script>
